<script setup lang="ts">
import { computed } from 'vue';

import type { LocationColor } from '@shared/api/graphql/gql/graphql';

import { locationColorStyle } from '../lib/location-color';

/** Локация коротким кодом и её цветом: рейл, переключатель, журналы и записи. */
const props = withDefaults(
  defineProps<{
    code: string;
    color?: LocationColor | null;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    solid?: boolean;
    title?: string;
  }>(),
  { color: null, size: 'sm', solid: false, title: undefined },
);

const SIZES = {
  xs: 'h-[18px] min-w-[18px] px-1 text-2xs',
  sm: 'h-6 min-w-6 px-1.5 text-2xs',
  md: 'h-7 min-w-7 px-1.5 text-2xs',
  lg: 'h-11 min-w-11 px-2 text-sm',
} as const;
/** Код из 4–5 знаков в крупном бейдже мельче, чтобы плашка влезала в рейл. */
const LG_LONG = 'h-11 min-w-11 px-1.5 text-2xs';

/** Сплошная заливка — для плашки «где я работаю», оттенок — для журналов и списков. */
const FILLS = {
  solid:
    'bg-[color-mix(in_srgb,var(--location-color)_var(--location-solid-depth),var(--text-primary))] text-[color-mix(in_srgb,var(--location-color)_var(--location-solid-ink-tint),var(--location-solid-ink))]',
  tint: 'bg-(--location-color)/22 text-[color-mix(in_srgb,var(--location-color)_65%,var(--text-primary))]',
} as const;

const sizeClass = computed(() => (props.size === 'lg' && props.code.length > 3 ? LG_LONG : SIZES[props.size]));
const colorStyle = computed(() => locationColorStyle(props.color));
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center justify-center rounded-md leading-none font-medium tabular-nums"
    :class="[sizeClass, FILLS[solid ? 'solid' : 'tint']]"
    :style="colorStyle"
    :title="title"
    :aria-label="title"
  >
    {{ code }}
  </span>
</template>
